import { useSoftphoneStore } from 'Modules/softphone/store';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';

const NOT_SELECTED = 'Not selected';

const labelFor = (
  devices: MediaDeviceInfo[],
  selectedId: string | null
): string => {
  if (!selectedId) {
    return NOT_SELECTED;
  }

  return (
    devices.find((device) => device.deviceId === selectedId)?.label ||
    selectedId
  );
};

/**
 * CallsAudioDevices - The devices this call is actually using, behind a disclosure
 *
 * Reads the selection from the store rather than from the call:
 */
export const CallsAudioDevices: React.FC = () => {
  const {
    microphones,
    speakers,
    ringers,
    selectedMicrophone,
    selectedSpeaker,
    selectedRinger,
  } = useSoftphoneStore(
    useShallow((state) => ({
      microphones: state.microphones,
      speakers: state.speakers,
      ringers: state.ringers,
      selectedMicrophone: state.selectedMicrophone,
      selectedSpeaker: state.selectedSpeaker,
      selectedRinger: state.selectedRinger,
    }))
  );

  const rows = [
    { label: 'Microphone', value: labelFor(microphones, selectedMicrophone) },
    { label: 'Speaker', value: labelFor(speakers, selectedSpeaker) },
    { label: 'Ringer', value: labelFor(ringers, selectedRinger) },
  ];

  return (
    <div className="border-t border-zinc-800">
      {rows.map(({ label, value }) => (
        <div
          key={label}
          className="flex items-center gap-2.5 border-b border-zinc-800 px-3 py-2.5 last:border-b-0"
        >
          <span className="w-20 flex-shrink-0 text-[11px] text-zinc-400">
            {label}
          </span>
          <span className="min-w-0 flex-1 truncate text-[11.5px] text-zinc-200">
            {value}
          </span>
        </div>
      ))}
    </div>
  );
};
